/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import { formatMoney, formatMontant } from "../../../utils/utils";
import { getDataByID } from "../../utils/fetchData";
import TopTableSkeleton from "./TopTableSkeleton";

const LineChartQuatre = (props) => {
  const [topAdherents, setTopAdherents] = useState([]);
  var [isPageLoading, setIsPageLoading] = useState(true);
  useEffect(() => {
    if (
      props?.auth?.user?.id &&
      (props?.auth?.user?.user_type === "ipm" ||
        props?.auth?.user?.user_type === "assurance_sante" ||
        props?.auth?.user?.user_type === "admin_ipm")
    ) {
      if (!props?.auth?.user?.admin_type) {
        getDataByID(
          `top10montantbyipm`,
          props?.auth?.user?.id,
          props?.auth?.token
        ).then((response) => {
          // console.log("response", response);
          setTopAdherents(response?.top10MontantBeneficiaire);
          setIsPageLoading(false);
        });
      } else {
        getDataByID(
          `top10montantbyipm`,
          props?.auth?.user?.id,
          props?.auth?.token
        ).then((response) => {
          setTopAdherents(response?.top10MontantBeneficiaire);
          setIsPageLoading(false);
        });
      }
    }
  }, [props?.auth]);

  const adhFormat = (cell, row) => {
    return row?.item?.prenom + " " + row?.item?.nom;
  };

  const adhIDFormat = (cell, row) => {
    return row?.item?.id;
  };

  const montantFormat = (cell, row) => {
    return formatMontant(cell);
  };

  const presFormat = (cell, row) => {
    return formatMoney(cell);
  };

  const options = {
    sizePerPage: 5,
    clearSearch: true,
    noDataText: "Aucune donnée disponible",
    expandBy: "column",
  };

  return (
    <div className="chart-item-container">
      <div className="row mb-2">
        <div className="col-xl-12 col-lg-12">
          <h2 className="chart-item-title">
            Top 10 des montants versés aux participants{" "}
          </h2>
        </div>
      </div>
      <div className="table-responsive">
        {isPageLoading && <TopTableSkeleton />}
        {!isPageLoading && (
          <BootstrapTable
            data={topAdherents}
            striped={true}
            hover={true}
            condensed={true}
            multiColumnSort={2}
            options={options}
            pagination
            search={false}
            version="4"
            bordered={false}
          >
            <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              dataField="item"
              isKey={true}
              hidden={false}
              expandable={false}
              width="50"
              dataFormat={adhIDFormat}
            >
              N°
            </TableHeaderColumn>
            <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              dataFormat={adhFormat}
              dataField="montant_adherent"
            >
              Participant
            </TableHeaderColumn>
            <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              width="200"
              dataAlign="right"
              dataFormat={montantFormat}
              dataField="montant"
            >
              Montant (F CFA)
            </TableHeaderColumn>
            {/* <TableHeaderColumn
              thStyle={{
                fontWeight: 600,
                fontSize: 16,
                color: "#1F497D",
              }}
              tdStyle={{
                fontWeight: 500,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
              }}
              dataFormat={entFormat}
              dataField="montant_entreprise"
            >
              Entreprises
            </TableHeaderColumn> */}
          </BootstrapTable>
        )}
      </div>
    </div>
  );
};

export default LineChartQuatre;
